import {API} from '../API';

export class ItemService {

  async saveItem(list, data) {
    let method = 'post';
    let url = `packing-lists/${list.id}/items`;
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteItem(list, item) {
    return (await API.getConnection())
      .delete(`packing-lists/${list.id}/items/${item.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async relistItems(list, items) {
    return (await API.getConnection())
      .put(`packing-lists/${list.id}/items`, {items})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
